import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100/70">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关于51cg吃瓜，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <details
              key={idx}
              className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 text-sm md:text-base font-heading font-semibold text-foreground-900 list-none">
                <span>{item.q}</span>
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 text-lg shrink-0 ml-3"></i>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}